import styled from "styled-components";

const defaultTextStyles = (theme) => `
    border-radius: 5px;
    font-weight: 500;
    font-size: 16px;
    letter-spacing: 0%
    line-height: 100%;
    padding: 12px 0 12px 0;
    border: none;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: all 400ms ease-in-out;  
    max-height: 42px;
    min-height: 42px;
    &:active {
        transform: translateY(+2px)  
    }
`;

const register = (theme, backgroundcolor) => `
        color: #fff;
    background-color: rgba(29, 109, 193, 1);
        &:hover {
        background-color: ${backgroundcolor};
        color: #fff;
        
        cursor: pointer;
       
    }
`;

const option2 = (theme, backgroundcolor, color) => `
        color: rgba(29, 109, 193, 1);
        border: 1px solid rgba(29, 109, 193, 1);
    background-color: #fff;
        &:hover {
        background-color: ${backgroundcolor};
        color: ${color};
        
        cursor: pointer;
       
    }
`;

const hint = (theme) => `
    font-size: ${theme.fontSizes.body};
`;

const error = (theme) => `
    color: ${theme.colors.text.error};
`;

const caption = (theme) => `
    font-size: ${theme.fontSizes.caption};
    font-weight: ${theme.fontWeights.bold};
`;

const label = (theme) => `
    font-family: ${theme.fonts.heading};
    font-size: ${theme.fontSizes.body};
    font-weight: ${theme.fontWeights.medium};
`;
const small = () => `
    width: 160px;
`;
const large = () => `
    width: 100%;
`;

const variants = {
  register,
  option2,
  label,
  caption,
  error,
  hint,
};
const sizes = {
  small,
  large,
};

export const Button = styled.button`
  ${({ theme }) => defaultTextStyles(theme)}
  ${({ variant, theme, backgroundcolor, color }) => variants[variant](theme, backgroundcolor, color)}
  ${({ size }) => sizes[size]?.()}
`;
Button.defaultProps = {
  variant: "register",
  size: "large",
  backgroundcolor: "rgba(29, 109, 193, 0.8)",
  color: "rgba(29, 109, 193, 1)"
};
